import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from "../../assets/Configuration";
import { TrainingSummaryModel } from '../models/training/training-summary.model';
import { CourseTemplateSummaryModel } from '../models/course/course-template-summary.model';
import { PagedResult } from '../models/paged-result.model';
import { GetTrainingsRequest } from '../models/training/trainings-request.model';
import { MyCompletedTrainingSummaryModel } from '../models/training/my-completed-training-summary.model';

@Injectable({
  providedIn: 'root',
})
export class MyTrainingsService {
  constructor(private httpClient: HttpClient) {}

  public getMyTrainings(): Observable<TrainingSummaryModel[]> {
    return this.httpClient.get<TrainingSummaryModel[]>(
      Configuration.getApiBaseUrl() + '/mytrainings/trainings'
    );
  }

  public getMyCourses(): Observable<CourseTemplateSummaryModel[]> {
    return this.httpClient.get<CourseTemplateSummaryModel[]>(
      Configuration.getApiBaseUrl() + '/mytrainings/courses'
    );
  }

  public getMyCompletedTrainings(request: GetTrainingsRequest)
    : Observable<PagedResult<MyCompletedTrainingSummaryModel>> 
  {
    return this.httpClient.post<PagedResult<MyCompletedTrainingSummaryModel>>(
      Configuration.getApiBaseUrl() + '/mytrainings/completed',
      request
    );
  }
}
